
const SupportSection = () => {
  return (
    <section className="py-20 bg-blue-50">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl font-bold text-gray-800 mb-8">
            地域密着の安心サポート体制
          </h2>
          <p className="text-xl text-gray-600 leading-relaxed mb-12">
            地域に根ざしたネットワークで、不動産に関するお悩みをワンストップで解決。<br />
            初めての方も安心してご相談ください。
          </p>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white rounded-lg p-8 shadow-lg">
              <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-shield-check-line text-white text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-3">
                安心の実績
              </h3>
              <p className="text-gray-600">
                地域での豊富な実績と信頼関係を基に、安心のサービスを提供
              </p>
            </div>
            
            <div className="bg-white rounded-lg p-8 shadow-lg">
              <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-team-line text-white text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-3">
                専門スタッフ
              </h3>
              <p className="text-gray-600">
                経験豊富な専門スタッフがお客様のニーズに合わせてサポート
              </p>
            </div>
            
            <div className="bg-white rounded-lg p-8 shadow-lg">
              <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-time-line text-white text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-3">
                迅速対応
              </h3>
              <p className="text-gray-600">
                お客様のご要望に迅速かつ丁寧に対応いたします
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SupportSection;
